var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbicacion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 217.109 217.109",
    viewBox: "0 0 217.109 217.109",
    xmlSpace: "preserve",
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.552 0C62.42 0 24.89 37.535 24.89 83.672c0 32.967 13.802 66.314 39.914 96.437 19.503 22.499 38.831 35.246 39.645 35.778a7.495 7.495 0 008.208 0c.813-.532 20.144-13.279 39.647-35.777 26.114-30.124 39.917-63.471 39.917-96.438C192.22 37.535 154.686 0 108.552 0zm0 200.4C93.165 188.934 39.89 144.806 39.89 83.672 39.89 45.806 70.691 15 108.552 15c37.864 0 68.668 30.806 68.668 68.672 0 61.134-53.28 105.262-68.668 116.728z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.557 50.449c-18.31 0-33.206 14.897-33.206 33.209 0 18.307 14.896 33.201 33.206 33.201 18.31 0 33.205-14.894 33.205-33.201 0-18.311-14.896-33.209-33.205-33.209zm0 51.41c-10.039 0-18.206-8.165-18.206-18.201 0-10.041 8.167-18.209 18.206-18.209 10.038 0 18.205 8.168 18.205 18.209 0 10.036-8.167 18.201-18.205 18.201z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/ubicacion.28d58ab87b004f2aaf03d620f74c331f.svg";
export { ForwardRef as ReactComponent };